import { Checkbox, Divider } from 'antd';
import { t } from 'ttag';
import './shippingLabelDevices.scss';

const CheckboxGroup = Checkbox.Group;

/**
 * Renders the Devices panel of the create-shipping-label page, letting the user pick which devices go on the label. Derives the select-all and indeterminate states by comparing selectedDevices against notInLabelDevices, then renders the titled panel around the device checkbox list, reporting every selection change through props.handleDevicesSelect.
 *
 * @param props - Panel props carrying notInLabelDevices, selectedDevices and handleDevicesSelect.
 * @returns The devices panel markup.
 */
const ShippingLabelDevices = (props: any) => {
  const { notInLabelDevices, selectedDevices } = props;

  const checkAll = notInLabelDevices.length === selectedDevices.length;
  const indeterminate =
    selectedDevices.length > 0 && selectedDevices.length < notInLabelDevices.length;

  /**
   * Selects or clears all devices available for the shipping label at once. Reads the checkbox's checked flag and reports either the full notInLabelDevices list or an empty array through props.handleDevicesSelect.
   *
   * @param e - Checkbox change event carrying target.checked.
   * @returns Nothing.
   */
  const handleDevicesSelectAll = (e: any) => {
    const { checked } = e.target;
    const selectedDevices = checked ? notInLabelDevices : [];
    props.handleDevicesSelect(selectedDevices);
  };

  /**
   * Renders the selectable device list for a shipping label, or an empty-state message. Shows 'There is no item' when notInLabelDevices is empty, otherwise a select-all Checkbox reflecting the checkAll and indeterminate flags above a CheckboxGroup bound to selectedDevices.
   *
   * @returns The device list markup or the empty-state element.
   */
  const deviceListRenderer = () => {
    if (!notInLabelDevices.length) {
      return <div className="no-data-message">{t`There is no item`}</div>;
    }

    return (
      <div>
        <Checkbox
          indeterminate={indeterminate}
          checked={checkAll}
          onChange={handleDevicesSelectAll}
        >
          {t`Select all`}
        </Checkbox>
        <Divider aria-hidden="true" />
        <CheckboxGroup
          className="shipping-label-devices__checkbox-group"
          options={notInLabelDevices}
          value={selectedDevices}
          onChange={props.handleDevicesSelect}
        />
      </div>
    );
  };

  return (
    <div className="shipping-label-devices">
      <div className="shipping-label-devices__title-container">
        <span className="title">{t`Devices`}</span>
      </div>
      <div className="shipping-label-devices__body-container">{deviceListRenderer()}</div>
    </div>
  );
};

export default ShippingLabelDevices;
